import { createContext } from "react";

export interface Email {
  id: string;
  subject: string;
  body: string;
  email: string;
  created_at: string;
  resend_id: string;
}

export interface EmailContextType {
  emails: Email[];
  fetchEmails: () => void;
  loading: boolean;
}

const defaultContext: EmailContextType = {
  emails: [],
  fetchEmails: () => {},
  loading: false,
};

export const EmailContext = createContext<EmailContextType>(defaultContext);
